import {
  ContactChannel,
  type SentFromCondition as SentFromConditionType,
} from "@redotech/redo-model/advanced-flow/rules-v3/schemas";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";

const channelOptions = [
  {
    id: ContactChannel.EMAIL,
    type: "text" as const,
    text: "Email",
    value: ContactChannel.EMAIL,
  },
];

export const SentFromCondition = memo(function SentFromCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: SentFromConditionType;
  onChange: (updated: SentFromConditionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const isEditable = (f: string) =>
    editableFields === undefined || editableFields.has(f);
  const channelEditable = isEditable("channel");
  const valuesEditable = isEditable("values");
  const [inputValue, setInputValue] = useState("");

  const selectedChannel = useMemo(
    () =>
      channelOptions.find(
        (opt) => opt.value === (condition.channel ?? ContactChannel.EMAIL),
      ),
    [condition.channel],
  );

  return (
    <Flex dir="column" gap="md" w="full">
      <RedoSingleSelectDropdownInput
        disabled={!channelEditable}
        options={channelOptions}
        optionSelected={({ item }) => {
          if (!channelEditable) {
            return;
          }
          onChange({ ...condition, channel: item.value, values: [] });
        }}
        placeholder="Select channel"
        selectedItem={selectedChannel}
      />
      {(condition.channel ?? ContactChannel.EMAIL) === ContactChannel.EMAIL && (
        <Flex
          style={
            valuesEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
          }
        >
          <RedoTagInputField
            inputValue={inputValue}
            label="Sender email address(es)"
            placeholder="Enter email addresses"
            setInputValue={setInputValue}
            setTags={(emails) => {
              if (!valuesEditable) {
                return;
              }
              const unique = Array.from(new Set(emails));
              onChange({ ...condition, values: unique });
            }}
            state="default"
            tags={(condition.values || []).map((v) => ({ text: v }))}
          />
        </Flex>
      )}
    </Flex>
  );
});
